import React from 'react';
import PatientFormTemplate from './components/PatientFormTemplate';

export default function PatientSocialHistoryForm() {
    return (
        <PatientFormTemplate formTitle="Your Adult Life" />
    );
}